import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Seo from "../components/Seo";
import Markdown from "../components/common/Markdown";
import { api } from "../lib/api";
import { fmtDate } from "../lib/format";
import NotFound from "./NotFound";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [missing, setMissing] = useState(false);
  useEffect(() => { api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setMissing(true)); }, [slug]);
  if (missing) return <NotFound />;
  if (!post) return <div className="min-h-[60vh]" />;
  const schema = { "@context": "https://schema.org", "@type": "Article", headline: post.title, author: { "@type": "Organization", name: post.author }, datePublished: post.created_at, image: post.cover_image };
  return (
    <article data-testid="blog-post">
      <Seo title={post.title} description={post.excerpt} path={`/blog/${slug}`} schema={schema} />
      <header className="bg-navy pb-32 pt-16">
        <div className="container-q max-w-4xl">
          <Link to="/blog" data-testid="blog-back-link" className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-white"><ArrowLeft size={16} /> All insights</Link>
          <p className="mt-8 text-xs font-semibold uppercase tracking-[0.2em] text-gold">{post.category} · {fmtDate(post.created_at)}</p>
          <h1 className="mt-4 text-4xl font-extrabold leading-tight text-white sm:text-5xl" data-testid="blog-post-title">{post.title}</h1>
          <p className="mt-4 text-slate-400">By {post.author}</p>
        </div>
      </header>
      <div className="container-q -mt-24 max-w-4xl pb-24">
        {post.cover_image && <img src={post.cover_image} alt={post.title} className="aspect-[16/9] w-full rounded-3xl object-cover shadow-2xl" />}
        <div className="mt-12"><Markdown content={post.content} /></div>
        <p className="mt-12 rounded-2xl bg-slate-100 p-5 text-xs text-slate-500">This content is for educational purposes only and does not constitute investment, insurance or tax advice.</p>
      </div>
    </article>
  );
}
